module.exports = __webpack_public_path__ + "img/TRT_SITE_Icon_Reward_Ribbon_Blue.8a45640b.png";